export default __webpack_public_path__ + "dfd98435fca3926a2f9898b4d7b627ee.svg";